module.exports = "<p>\r\n  portfoliostaffperformance works!\r\n</p>\r\n"